import { StyledListCell, StyledListCellRow } from '../Table.style';
import { setQueryFilter } from 'components/GridChipFilterContainer/helpers';

const TeamRow = ({ team }) => {
  return (
    <StyledListCellRow onClick={() => setQueryFilter({ teams: team.id })}>
      {team.name}
    </StyledListCellRow>
  );
};

const TeamsCell = ({ teams }) => {
  return (
    <StyledListCell>
      {teams.map(team => (
        <TeamRow key={team.id} team={team} />
      ))}
    </StyledListCell>
  );
};

export default TeamsCell;
